// extracted by mini-css-extract-plugin
export default {"validationDiv":"expendUserAc_validationDiv__8FL3-","taskBtn":"expendUserAc_taskBtn__5rUuW","validation":"expendUserAc_validation__nl9I5","editSpan":"expendUserAc_editSpan__vZp9J"};